import { Injectable } from '@angular/core';
import { marked } from 'marked';

@Injectable({ providedIn: 'root' })
export class ClipboardService {

  // Copy markdown content so rich-text targets (Word, Outlook, email composers) receive
  // rendered HTML while plain-text targets receive stripped text. Falls back to plain
  // writeText() on environments without ClipboardItem support.
  async copyMarkdown(markdown: string): Promise<boolean> {
    if (!markdown) return false;

    const html = marked.parse(markdown, { async: false }) as string;
    const plainText = this.htmlToPlainText(html);

    try {
      if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
        await navigator.clipboard.write([
          new ClipboardItem({
            'text/html': new Blob([html], { type: 'text/html' }),
            'text/plain': new Blob([plainText], { type: 'text/plain' }),
          }),
        ]);
        return true;
      }
    } catch {
      // Fall through to plain-text write below
    }

    try {
      await navigator.clipboard.writeText(plainText);
      return true;
    } catch {
      return false;
    }
  }

  async copyText(text: string): Promise<boolean> {
    if (!text) return false;
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  }

  private htmlToPlainText(html: string): string {
    if (typeof document === 'undefined') return html;
    const div = document.createElement('div');
    div.innerHTML = html;
    return (div.innerText || div.textContent || '').trim();
  }
}
